var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade pt-popin-cds",
      attrs: {
        id: _vm.id,
        "aria-labelledby": _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
        "data-ob1-component": "Popin",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content pb-0 px-1 px-md-2" }, [
          _vm.radioButtonOfferSelected
            ? _c("div", [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body px-0" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 px-2 px-md-3 px-lg-5" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-10" }, [
                          _vm.showBanner(_vm.radioButtonOfferSelected.banner)
                            ? _c("strong", {
                                directives: [
                                  {
                                    name: "msh-html",
                                    rawName: "v-msh-html",
                                    value: _vm.radioButtonOfferSelected.banner,
                                    expression:
                                      "radioButtonOfferSelected.banner",
                                  },
                                ],
                                staticClass: "ob1-tag ob1-tag-primary mb-1",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("h2", { staticClass: "visually-hidden" }, [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm.nameAccessibility) +
                                "\n                                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "fw-bold py-0 mb-0",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(
                                    _vm.radioButtonOfferSelected.offerType
                                  ) +
                                  "\n                                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "h2",
                            {
                              staticClass: "h1 py-0 mb-0",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(
                                    _vm.radioButtonOfferSelected
                                      .secondaryShortLabel
                                  ) +
                                  "\n                                    "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2 d-flex justify-content-end" },
                          [
                            _vm.radioButtonOfferSelected.is5G
                              ? _c("img", {
                                  staticClass: "logo-5g-popin",
                                  attrs: {
                                    src: _vm.logo5gSrc,
                                    alt: "logo 5G Orange",
                                    "aria-hidden": "true",
                                  },
                                })
                              : _vm.radioButtonOfferSelected.is5GPlus
                              ? _c("img", {
                                  staticClass: "logo-5g-popin",
                                  attrs: {
                                    src: _vm.logo5gPlusSrc,
                                    alt: "logo 5G+ Orange",
                                    "aria-hidden": "true",
                                  },
                                })
                              : _vm._e(),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mb-2" }, [
                        _vm.getNewSubMessage(_vm.radioButtonOfferSelected)
                          ? _c(
                              "div",
                              { staticClass: "col-12 text-gray3 fw-bold" },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.getNewSubMessage(
                                        _vm.radioButtonOfferSelected
                                      )
                                    ) +
                                    "\n                                "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            {
                              class: _vm.isShowOpenDiscountMessage
                                ? "my-1 px-1 bg-greige"
                                : "mb-0",
                            },
                            [
                              _vm.radioButtonOfferSelected.openDiscountMessage
                                ? [
                                    _c("div", {
                                      staticClass:
                                        "fw-bold small text-dark pt-1 pb-0 pe-1",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.radioButtonOfferSelected
                                            .openDiscountMessage
                                        ),
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c("Price", {
                                attrs: {
                                  price:
                                    _vm.radioButtonOfferSelected.price.price,
                                  "initial-price":
                                    _vm.radioButtonOfferSelected.price
                                      .initialPrice,
                                  "price-details": _vm.radioButtonOfferSelected
                                    .price.priceDetails
                                    ? _vm.radioButtonOfferSelected.price
                                        .priceDetails
                                    : undefined,
                                  "show-from":
                                    _vm.radioButtonOfferSelected.price.showFrom,
                                  "show-by-month":
                                    _vm.radioButtonOfferSelected.price
                                      .showByMonth,
                                  "show-promo-duration":
                                    _vm.radioButtonOfferSelected.price
                                      .showPromoDuration,
                                  "show-promo-duration-first-months":
                                    _vm.radioButtonOfferSelected.price
                                      .showPromoDurationFirstMonths,
                                  "show-children-promotion-price":
                                    _vm.radioButtonOfferSelected.price
                                      .showChildrenPromotionPrice,
                                  duration:
                                    _vm.radioButtonOfferSelected.price.duration,
                                  "is-cents-format": false,
                                  "is-compact": true,
                                  "is-inverse": false,
                                },
                              }),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.radioButtonOfferSelected.claims
                          ? _c("div", { staticClass: "col-12" }, [
                              _c(
                                "ul",
                                {
                                  staticClass: "row list-unstyled",
                                  attrs: {
                                    "aria-label": "Avantages du forfait",
                                  },
                                },
                                _vm._l(
                                  _vm.radioButtonOfferSelected.claims,
                                  function (claim, index) {
                                    return _c(
                                      "li",
                                      { key: index },
                                      [
                                        _c("offer-claim", {
                                          key: index,
                                          attrs: { claim: claim },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.blockedUnBlockedOffer
                          ? _c(
                              "div",
                              { attrs: { id: "version-blocked-selection" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "lead fw-bold pt-2 pb-0" },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.radioButtonOfferSelected
                                            .miniOfferCdsTypeLabel
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("ob1-radio-button-list", {
                                  attrs: {
                                    "with-column-layout": true,
                                    "radios-buttons":
                                      _vm.radioButtonBlockedUnBlockedDTO,
                                  },
                                  on: { change: _vm.onVersionChange },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mb-4" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            {
                              staticClass: "accordion",
                              attrs: {
                                itemscope: "",
                                itemtype: "https://schema.org/FAQPage",
                              },
                            },
                            _vm._l(
                              _vm.radioButtonOfferSelected.detailAttributes,
                              function (detailAttribute, attributeIndex) {
                                return _c(
                                  "div",
                                  {
                                    key:
                                      _vm.radioButtonOfferSelected.idSeo +
                                      "-" +
                                      attributeIndex,
                                    staticClass: "card multi",
                                    attrs: {
                                      itemscope: "",
                                      itemprop: "mainEntity",
                                      itemtype: "https://schema.org/Question",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "card-header" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "collapsed",
                                          attrs: {
                                            id:
                                              "faqQuestion-" +
                                              _vm.radioButtonOfferSelected
                                                .idSeo +
                                              "-" +
                                              attributeIndex,
                                            "data-bs-toggle": "collapse",
                                            "data-bs-target":
                                              "#faqAnswer-" +
                                              _vm.radioButtonOfferSelected
                                                .idSeo +
                                              "-" +
                                              attributeIndex,
                                            "aria-controls":
                                              "faqAnswer-" +
                                              _vm.radioButtonOfferSelected
                                                .idSeo +
                                              "-" +
                                              attributeIndex,
                                            "aria-expanded": "false",
                                            type: "button",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "accordion-card-title",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "accordion-title mb-0",
                                                  attrs: { itemprop: "name" },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        detailAttribute.titleAttribute
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", {
                                                staticClass:
                                                  "accordion-icon mb-0",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "collapse",
                                        attrs: {
                                          id:
                                            "faqAnswer-" +
                                            _vm.radioButtonOfferSelected.idSeo +
                                            "-" +
                                            attributeIndex,
                                          "aria-labelledby":
                                            "faqQuestion-" +
                                            _vm.radioButtonOfferSelected.idSeo +
                                            "-" +
                                            attributeIndex,
                                          role: "region",
                                          itemscope: "",
                                          itemprop: "acceptedAnswer",
                                          itemtype: "https://schema.org/Answer",
                                        },
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "accordion-card-body standard",
                                          attrs: { itemprop: "text" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              detailAttribute.textAttribute
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.radioButtonOfferSelected.legalMentions
                        ? _c(
                            "div",
                            { staticClass: "pb-2" },
                            [
                              _c(
                                "ob1-liens-haut-bas",
                                {
                                  attrs: {
                                    "button-id":
                                      _vm.radioButtonOfferSelected.legalMentions
                                        .title.headerId,
                                    "button-label":
                                      _vm.radioButtonOfferSelected.legalMentions
                                        .title.title,
                                    "collapsed-block-id":
                                      _vm.radioButtonOfferSelected.idSeo +
                                      "-" +
                                      _vm.radioButtonOfferSelected.legalMentions
                                        .title.textId,
                                  },
                                },
                                _vm._l(
                                  _vm.radioButtonOfferSelected.legalMentions
                                    .mentions,
                                  function (mention, index) {
                                    return _c(
                                      "div",
                                      {
                                        key:
                                          "mentiontext-" +
                                          _vm.radioButtonOfferSelected.idSeo +
                                          "-" +
                                          index,
                                      },
                                      [
                                        mention.title
                                          ? _c("strong", [
                                              _vm._v(_vm._s(mention.title)),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        mention.text
                                          ? _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(mention.text),
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "sticky-bottom py-2 bg-white modal-footer d-flex justify-content-center",
                  },
                  [
                    _vm.isAddOfferWithPopin
                      ? _c("offer-cta-with-device-popin", {
                          attrs: {
                            "is-wide": false,
                            "is-primary": true,
                            "from-cds": true,
                            "is-sub": _vm.isSub,
                            label: _vm.getCtaLabel(
                              _vm.radioButtonOfferSelected
                            ),
                            "offer-name": _vm.radioButtonOfferSelected.name,
                            "popin-id":
                              "addOfferWithDevicePopIn-" +
                              _vm.radioButtonOfferSelected.idSeo,
                            "popin-ctas-dto":
                              _vm.radioButtonOfferSelected.addOfferDto
                                .popinWithDeviceCdsDto,
                            "tracking-category": "overlay_forfait",
                            "tracking-label": _vm.getLabelToTmsFormat(
                              _vm.radioButtonOfferSelected.name
                            ),
                          },
                        })
                      : _vm.radioButtonOfferSelected.addOfferDto
                      ? _c("ob1-boutons", {
                          attrs: {
                            "is-button": false,
                            "is-primary": true,
                            "is-wide": false,
                            label: _vm.getCtaLabel(
                              _vm.radioButtonOfferSelected
                            ),
                            href: _vm.radioButtonOfferSelected.addOfferDto.link,
                            "data-oevent-category": "overlay_cta",
                            "data-oevent-action": _vm.getLabelToTmsFormat(
                              _vm.getCtaLabel(_vm.radioButtonOfferSelected)
                            ),
                            "data-oevent-label": _vm.getLabelToTmsFormat(
                              _vm.radioButtonOfferSelected.name
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.radioButtonOfferSelected.addOfferWithAuthenticationDto
                      ? _c("offer-cta-with-device-popin", {
                          attrs: {
                            "is-wide": false,
                            "is-primary": true,
                            "from-cds": true,
                            "is-sub": _vm.isSub,
                            label: _vm.getCtaLabel(
                              _vm.radioButtonOfferSelected
                            ),
                            "offer-name": _vm.radioButtonOfferSelected.name,
                            "popin-id":
                              "addOfferWithAuthenticationAndDevicePopIn-" +
                              _vm.radioButtonOfferSelected.idSeo,
                            "popin-ctas-dto":
                              _vm.radioButtonOfferSelected
                                .addOfferWithAuthenticationDto
                                .popinWithDeviceCdsDto,
                            "tracking-category": "overlay_cta",
                            "tracking-label": _vm.getLabelToTmsFormat(
                              _vm.radioButtonOfferSelected.name
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.radioButtonOfferSelected.addOfferInCartDto
                      ? _c("ob1-boutons", {
                          staticClass: "mx-0 px-0 w-100",
                          attrs: {
                            "is-button": true,
                            "is-primary": true,
                            label:
                              _vm.radioButtonOfferSelected.addOfferInCartDto
                                .label,
                            "data-oevent-category": "tuile_forfait_vsim",
                            "data-oevent-action": "ajouter_au_panier",
                            "data-oevent-label":
                              _vm.radioButtonOfferSelected.name,
                          },
                          on: {
                            "ob1-boutons-click": function ($event) {
                              $event.preventDefault()
                              return _vm.onAddOfferInCart()
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "btn-close pt-2 pt-md-0",
          staticStyle: { display: "block !important" },
          attrs: {
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Fermer",
          },
        },
        [
          _c("span", {
            staticClass: "icon icon-delete",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-close ob1-link-arrow back",
          staticStyle: { display: "none !important" },
          attrs: { type: "button", "data-bs-dismiss": "modal" },
        },
        [_vm._v("\n                        Fermer\n                    ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }